import { Breadcrumb, Layout, Spin, Form, Input, DatePicker, Button, Row, Col, Card, message, Select } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Headerdiv from '../../layout/header';
import Footerdiv from '../../layout/footer';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axiosClient from '../../../api/axiosClient';
import { APPBACKGROUND_COLOR } from '../../appsettings';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import dayjs from 'dayjs';

const { TextArea } = Input;

const EditRecord = () => {
    const [form] = Form.useForm();
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const USERID = window.localStorage.getItem('USERID');
    const [inventoryItems, setInventoryItems] = useState([]);

    const fetchInventoryItems = async () => {
        try {
            const response = await axiosClient.get('/inventory/get_all_inventory_dropdown.php');
            const result = response.data;

            if (result.status === 'success') {
                setInventoryItems(result.data);
            } else {
                message.error(result.message || 'Failed to fetch inventory items.');
            }
        } catch (error) {
            console.error('Fetch inventory items error:', error);
            message.error(error.response?.data?.message || 'Network error.');
        }
    };

    const fetchRecord = async () => {
        setLoading(true);
        try {
            const response = await axiosClient.get(`/inventory/record/get_record_by_id.php?id=${id}`);
            const result = response.data;

            if (result.status === 'success') {
                const record = result.data;
                form.setFieldsValue({
                    ...record,
                    date: record.date ? dayjs(record.date) : null,
                });
            } else {
                message.error(result.message || 'Failed to fetch record details.');
                navigate('/inventory/records');
            }
        } catch (error) {
            console.error('Fetch record error:', error);
            message.error(error.response?.data?.message || 'Network error.');
            navigate('/inventory/records');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInventoryItems();
        if (id) {
            fetchRecord();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            id,
            ...values,
            date: values.date ? values.date.format("YYYY-MM-DD") : null,
            by: USERID,
            status: values.record_status,
        };

        try {
            const response = await axiosClient.post('/inventory/record/update_record.php', payload);
            const data = response.data;

            if (data.status === "success") {
                message.success(data.message);
                navigate('/inventory/records');
            } else {
                message.error(data.message || "Failed to update record.");
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error(error.response?.data?.message || "Failed to connect to server.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Spin spinning={loading} tip="Loading...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR, minHeight: '100vh' }}>
                <Headerdiv />
                <Content style={{ padding: "10px" }}>
                    <Breadcrumb style={{ marginBottom: 10 }}>
                        <Breadcrumb.Item><Link to={"/inventory/itemList"}>Inventory</Link></Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={"/inventory/records"}>Records</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Edit Record</Breadcrumb.Item>
                    </Breadcrumb>

                    <Form layout="vertical" form={form} onFinish={onFinish}>
                        <Card title="Edit Record">
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="inventory_id"
                                        label="Inventory Item"
                                        rules={[{ required: true, message: "Inventory Item is required" }]}
                                    >
                                        <Select placeholder="Select Inventory Item" showSearch optionFilterProp="children">
                                            {inventoryItems.map((item) => (
                                                <Select.Option key={item.id} value={item.id}>
                                                    {item.item_code} - {item.value}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="type"
                                        label="Type"
                                        rules={[{ required: true, message: "Type is required" }]}
                                    >
                                        <Input placeholder="Enter Type (e.g., Maintenance, Repair)" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="date"
                                        label="Date"
                                        rules={[{ required: true, message: "Date is required" }]}
                                    >
                                        <DatePicker style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>


                                <Col xs={24} sm={12} md={6}>
                                    <Form.Item
                                        name="record_status"
                                        label="Status"
                                        rules={[{ required: true, message: "Status is required" }]}
                                        initialValue="Closed"
                                    >
                                        <Select placeholder="Select Status">
                                            <Select.Option value="Closed">Closed</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item name="description" label="Description">
                                        <ReactQuill theme="snow" placeholder="Enter Description" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Form.Item name="note" label="Note">
                                        <TextArea rows={2} placeholder="Enter Note" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24}>
                                    <Row justify="end" gutter={[10, 10]} style={{ marginTop: 10 }}>
                                        <Col>
                                            <Button onClick={() => navigate('/inventory/records')}>Cancel</Button>
                                        </Col>
                                        <Col>
                                            <Button type="primary" htmlType="submit">
                                                Update Record
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Card>
                    </Form>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default EditRecord;
